import { createContext, useContext, ReactNode } from 'react';

const CertificationApiContext = createContext<string>('/admin/certification');

export function useCertificationApi(): string {
  return useContext(CertificationApiContext);
}

export function CertificationApiProvider({
  apiBase,
  children,
}: {
  apiBase: string;
  children: ReactNode;
}) {
  return (
    <CertificationApiContext.Provider value={apiBase}>
      {children}
    </CertificationApiContext.Provider>
  );
}
